export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/auth/login-ico-sns-apple-b5e4e1e88f03d0d7f5014ad69e1683f9.svg";